import { CanMatchFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { UserService } from '@services/user.service';
import { EUserRole } from '@modules/iam/enum/user.role.enum';

export const roleGuard: CanMatchFn = (route): boolean | UrlTree => {
    const userService = inject(UserService);
    const router = inject(Router);
    const user = userService.user;
    if (!user()._id) return router.createUrlTree(['/auth', 'sign-in']);

    const allowedRoles = (route.data?.['allowedRoles'] as EUserRole[] | undefined) ?? [];
    const allowed = allowedRoles.length === 0 || allowedRoles.includes(user().role);
    return allowed ? true : router.createUrlTree(['/dashboard']);
};
